import { axios } from '@/axios-client'

export class EmailPreviewer {
  btnSelector
  subjectSelector
  bodySelector
  placeholders

  constructor(btnSelector, { subject, body, placeholders }) {
    this.btnSelector = btnSelector
    this.subjectSelector = subject
    this.bodySelector = body
    this.placeholders = placeholders
  }

  createHtml(subject, body) {
    return `
      <div class="preview container">
        <div class="subject">
          <input type="text" value="${subject}" disabled>
        </div>
        <div class="body">
          <textarea disabled>${body}</textarea>
        </div>
      </div>
    `
  }

  createErrorHtml(invalidVariables) {
    const errorRows = invalidVariables.map(v => `<div>・${v}</div>`).join('')
    return `
      <div class="preview container">
        ${errorRows}
      </div>
    `
  }

  openPreview(subject, body) {
    Swal.fire({
      title: '返信テンプレートプレビュー',
      html: this.createHtml(subject, body),
      showCloseButton: false,
    })
  }

  showInvalidVariables(invalidVariables) {
    Swal.fire({
      title: '使用できない変数が含まれています',
      html: this.createErrorHtml(invalidVariables),
      showCloseButton: false,
    })
  }

  async bind(scope) {
    const withScope = selector => scope ? `${scope} ${selector}` : selector

    $(withScope(this.btnSelector)).on('click', async event => {
      event.preventDefault()
      const url = event.target.href
      const params = {
        subject: $(withScope(this.subjectSelector)).val(),
        body: $(withScope(this.bodySelector)).val(),
        placeholders: this.placeholders,
      }

      const { subject, body, invalid_variables } = await axios.post(url, params)
      if (subject === undefined) {
        return
      }

      if (invalid_variables.length > 0) {
        this.showInvalidVariables(invalid_variables)
      } else {
        this.openPreview(subject, body)
      }
    })
  }
}
